import { useContext, useCallback } from 'react';
import { setTranslationValues, TranslationContext } from '@pascal/pascal-core';

const useTranslation = () => {
  const translations = useContext(TranslationContext);
  return useCallback(
    (key, objWithTranslationValues = {}) => {
      let translatedText =
        Object.keys(translations).length && translations[key] ? translations[key] : key;

      if (objWithTranslationValues && Object.keys(objWithTranslationValues).length) {
        translatedText = setTranslationValues(translatedText, objWithTranslationValues);
      }

      return translatedText;
    },
    [translations]
  );
};

export default useTranslation;
